import { ReactElement } from 'react'

export function RadioNotSelected(props: { className?: string }): ReactElement {
  const maskId = `mask_${Math.random()}`
  const url = `url(#${maskId})`
  return (
    <svg
      className={props.className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10.7334C0 5.2134 4.48 0.733398 10 0.733398C15.52 0.733398 20 5.2134 20 10.7334C20 16.2534 15.52 20.7334 10 20.7334C4.48 20.7334 0 16.2534 0 10.7334ZM2 10.7334C2 15.1534 5.58 18.7334 10 18.7334C14.42 18.7334 18 15.1534 18 10.7334C18 6.3134 14.42 2.7334 10 2.7334C5.58 2.7334 2 6.3134 2 10.7334Z"
          fill="white"
        />
      </mask>
      <g mask={url}>
        <rect x="-2" y="-1.2666" width="24" height="24" fill="#525252" />
      </g>
    </svg>
  )
}
